import { supabase } from "@/lib/supabase/supabaseClient";
import {
  SyncSurveysWithTemplateProps
} from ".";
import { checkMultipleSurveysForDangerousChanges } from "./lib/checkMultipleSurveysForDangerousChanges";
import { Tables, TablesInsert } from "@/lib/supabase/supabase_types_override";

export const checkSyncSurveysWithTemplate = async ({
  surveyTemplateId,
  changes
}: SyncSurveysWithTemplateProps) => {
  const surveyTemplateWithQuestionsRes = await supabase
    .from("survey_bank")
    .select("*,question:survey_bank_question_bank!inner(*)")
    .eq("id", surveyTemplateId)
    .single();
  if (
    surveyTemplateWithQuestionsRes.error ||
    !surveyTemplateWithQuestionsRes.data
  ) {
    throw (
      surveyTemplateWithQuestionsRes.error ||
      new Error("Survey template not found")
    );
  }
  const surveysToCheckResWithQuestionsAndResponses = await supabase
    .from("survey")
    .select("*,question!inner(*,response(*)),crm(*)")
    .eq("survey_bank_ref_id", surveyTemplateId);
  if (surveysToCheckResWithQuestionsAndResponses.error) {
    throw surveysToCheckResWithQuestionsAndResponses.error;
  }
  console.log(surveyTemplateWithQuestionsRes.data);
  console.log(surveysToCheckResWithQuestionsAndResponses.data);
  // Custom merge logic to handle question arrays properly
  const mergedSurveyTemplateWithChanges = {
    ...surveyTemplateWithQuestionsRes.data,
    ...changes,
    question: mergeQuestions(
      surveyTemplateWithQuestionsRes.data.question || [],
      changes?.question || []
    )
  };

  function mergeQuestions(
    originalQuestions: Tables<"survey_bank_question_bank">[],
    changedQuestions: Tables<"survey_bank_question_bank">[]
  ) {
    const questionMap = new Map(originalQuestions.map(q => [q.id, { ...q }]));

    changedQuestions.forEach(changedQ => {
      if (questionMap.has(changedQ.id)) {
        questionMap.set(changedQ.id, { ...questionMap.get(changedQ.id), ...changedQ });
      } else {
        questionMap.set(changedQ.id, changedQ);
      }
    });

    return Array.from(questionMap.values());
  }
  return checkMultipleSurveysForDangerousChanges(
    surveysToCheckResWithQuestionsAndResponses.data,
    mergedSurveyTemplateWithChanges
  );
};
